import { render, staticRenderFns } from "./ApprovedAccounts.vue?vue&type=template&id=622f5d23&scoped=true"
import script from "./ApprovedAccounts.vue?vue&type=script&lang=js"
export * from "./ApprovedAccounts.vue?vue&type=script&lang=js"
import style0 from "./ApprovedAccounts.vue?vue&type=style&index=0&id=622f5d23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f5d23",
  null
  
)

export default component.exports